/**
 * A utility function that assigns a derived value using the provided function.
 *
 * This function is useful to prevent the creation of Immediately Invoked Function Expressions (IIFE)
 * within the component body.
 *
 * @template TData - The type of the derived data.
 * @param {() => TData} derive - A function that returns the derived value.
 * @returns {TData} - The derived value.
 */
export const useDerivedValue = <TData>(derive: () => TData): TData => {
  return derive();
};
